export default __webpack_public_path__ + "static/childress-1dfa81b92fe08c34b03aa9ce5bfc039c.jpg";